import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import counterReducer from '@/features/counter/counterSlice'
import playlistSlice from '@/features/playlist/playlistSlice'
import authSlice from '@/features/spotifyAuth/authSlice'
import favoriteSlice from '@/features/favorite/favoriteSlice'
import searchSlice from '@/features/search/searchSlice'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import singleTrackSlice from '@/features/singleTrack/singleTrackSlice'

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['counter', 'playlist', 'auth', 'favorite', '', 'singleTrack'],
  blacklist: ['']
}

const reducers = combineReducers({
  counter: counterReducer,
  auth: authSlice,
  playlist: playlistSlice,
  favorite: favoriteSlice,
  search: searchSlice,
  singleTrack: singleTrackSlice
})
const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
